import type { TransactionFrequencyTimePeriod } from './transaction-frequency-limit.types';

export const TRANSACTION_FREQUENCY_MAX_ROWS = 4;

export const periodOptions: { label: string; value: TransactionFrequencyTimePeriod }[] = [
  { label: 'Daily', value: 'DAY' },
  { label: 'Weekly', value: 'WEEK' },
  { label: 'Monthly', value: 'MONTH' },
  { label: 'Total', value: 'TOTAL' },
];

export const periodOptionsExcludingTotal: {
  label: string;
  value: Exclude<TransactionFrequencyTimePeriod, 'TOTAL'>;
}[] = [
  { label: 'Daily', value: 'DAY' },
  { label: 'Weekly', value: 'WEEK' },
  { label: 'Monthly', value: 'MONTH' },
];
